<div class="table-container branch-table-container" [class.table-container--loading]="isLoading">
  <mat-table matSort [dataSource]="dataSource">
    <ng-container matColumnDef="expand">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let element" class="mat-column-expand" [ngClass]="{'align-top': expandedBranchId === element.branchId, 'expand-margin': expandedBranchId === element.branchId}">
        <button mat-icon-button (click)="toggleMembers(element.branchId); $event.stopPropagation()" [disabled]="!(element.employeeIds?.length)">
          <mat-icon>{{ expandedBranchId === element.branchId ? "expand_less" : "expand_more" }}</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ "footers.branch" | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="{'align-top': expandedBranchId === element.branchId}">{{ element.name }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="employeesCount">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ "footers.memberCount" | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="{'align-top': expandedBranchId === element.branchId}">
        <div *ngIf="expandedBranchId !== element.branchId" class="cell-content">{{ element.employeeIds?.length ?? 0 }}</div>
        <div *ngIf="expandedBranchId === element.branchId">
          <mat-spinner *ngIf="loadingBranchId === element.branchId" diameter="24" class="branch-members-spinner"></mat-spinner>
          <mat-list *ngIf="loadingBranchId !== element.branchId" class="branch-members-list">
            <mat-list-item *ngFor="let member of getMembers(element.branchId)" class="branch-members">
              {{ member.fullName || member.email }}
            </mat-list-item>
          </mat-list>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="assign">
      <mat-header-cell *matHeaderCellDef>{{ "footers.set" | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="{'align-top': expandedBranchId === element.branchId}">
        <div class="table-actions">
          <button type="button" class="action-btn" (click)="assign(element.branchId); $event.stopPropagation()" [disabled]="updating">
            <mat-icon>check</mat-icon>
            {{ (updating ? "footers.setting" : "footers.set") | translate }}
          </button>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" (click)="toggleMembers(row.branchId)"></mat-row>
  </mat-table>

  <div class="loading-wrapper" *ngIf="isLoading">
    <app-loading [hideText]="true"></app-loading>
  </div>
</div>
